import styleForm from "../scss/form.module.scss";
import { TextsContext } from '../context/textsContext';
import React, { useState, useContext } from "react";
import { useCotizador } from "../context/apiContext";
import { Fragment } from "react";
import ValidaComponent from "./ValidaComponent";
import { useBenefitComplement } from "hooks/cotizador/BenefitComplementHook";
import { useBoolComplement } from "hooks/cotizador/BoolComplementHook";
import { transformData } from "./utils/RequestQuoter.util";
import { quoter } from "api/feature/quoterApi";
import { updateContext } from "helpers/UpdateBenefitsContext";

const SelectBenefitsComponent = ({
    providersSignificant = false,
    setProviders, setMaternity, setRecienNacido, className, benefits, benefit, setMostrarPais = () => {
    },
    complements = "", boolComplements = "", validator = true
}) => {
    const { texts, getCurrentLanguage } = useContext(TextsContext);
    const {
        handleOnChangeBenefit,
        removeBenefits,
        selectedBenefits,
        ignoredBenefits,
        selectedBenefitsNames,
        changeDataValue,
        preferreds,
        addCalculation,
        contextState
    } = useCotizador();
    const [isOpen, setIsOpen] = useState(false);
    const complementsHandler = useBenefitComplement(complements);
    const boolComplementsHandler = useBoolComplement(boolComplements);

    const getOptions = () => {
        try {
            if (!benefits?.length || !benefit) return [];
            let newList = benefits
                .filter((i) => i["factorId.id"] === benefit)
                .filter((i) => !ignoredBenefits.includes(i.id))
                ;

            newList.sort(
                (a, b) => {
                    if (newList.map(i => extractNumberFromString(i?.description)).every(i => isNaN(i))) {
                        if (preferreds.includes(b.id)) return -1;
                        if (a.description < b.description) {
                            return -1;
                        }
                        if (a.description > b.description) {
                            return 1;
                        }
                        return 0;
                    }
                    return extractNumberFromString(b?.description) -
                        extractNumberFromString(a?.description)
                }
            )

            if (benefit === "maxcovpipoly") {
                newList.sort(
                    (a, b) => {
                        if (preferreds.includes(a.id)) return 1;
                        return extractNumberFromString(b?.description) -
                            extractNumberFromString(a?.description)
                    }
                )
                newList = newList.filter(i => i.id !== 82);
            }
            if (benefit === "Deductible elimination") {

                newList.sort(
                    (a, b) => {

                        // If description is "none", move to start
                        if (a.description.toLowerCase() === "none") return -1;
                        if (b.description.toLowerCase() === "none") return 1;

                        // Otherwise, sort alphabetically
                        if (a.description < b.description) return -1;
                        if (a.description > b.description) return 1;

                        return 0; // equal descriptions
                    }
                )
            }

            return newList;
        } catch (e) {
            return [];
        }

    };

    const extractNumberFromString = (inputString) => {
        if (!inputString) return NaN;
        const stringWithoutCommas = String(inputString).replace(/,/g, "");
        const match = stringWithoutCommas.match(/[\d.]+/);

        if (match) {
            const numberString = match[0];
            return parseFloat(numberString);
        }

        return NaN;
    };

    const isPreferred = (id) => {
        return preferreds.includes(id);
    };


    // useEffect(() => {
    //     if (!selectedBenefitsIds[benefit]) {
    //         const preferred = getOptions().find((i) => isPreferred(i.id));
    //         let selected = null;
    //         if (preferred) selected = preferred;
    //         if (!preferred && benefit != "Providers Network" ) selected = getOptions()?.length && getOptions()[0];
    //         if (benefit === "Providers Network") selected = getOptions()[1];
    //         const value = selected?.factor;
    //
    //         if (value) {
    //             const name = benefit;
    //             handleOnChangeBenefit({target: {value, name}}, {text: selected?.description, id: selected?.id});
    //
    //         }
    //     }
    // }, []);

    if (benefit === "geogrcov") {
        setMostrarPais?.(selectedBenefitsNames[benefit]);
    }

    if (benefit === "provdnet") {
        setProviders?.(selectedBenefitsNames[benefit]);
    }

    if (benefit === "Maternity and cesarean") {
        setMaternity?.(selectedBenefitsNames[benefit]);
    }

    if (benefit === "matrnity") {
        setRecienNacido?.(selectedBenefitsNames[benefit]);
    }

    const handleOnChangeBenefitWrapper = (e) => {

        let updatedContext = contextState

        if (e.target.value === 'dednonusa_50000') {
            const name = 'coinsurance'
            const value = 'coinsurance_no'
            const selectedIndex = 0
            const options = [{
                dataset: {
                    id: 'coinsurance_no',
                    description: 'No'
                }
            }]

            handleOnChangeBenefit({ target: { value, name, selectedIndex, options } })
            updatedContext = updateContext({ target: { value, name, selectedIndex, options } }, updatedContext)
        }

        if (e.target.name === 'dednonusa') {
            removeBenefits('dedusa')
        }

        if (complements) {
            complementsHandler.updateComplements();
        }
        if (boolComplements) {
            boolComplementsHandler.updateComplements();
        }
        handleOnChangeBenefit(e);

        try {

            const reqQuoter = transformData(updateContext(e, updatedContext), getCurrentLanguage(), null)

            quoter(reqQuoter)
                .then(response => {

                    if (response && response !== undefined && response?.data !== null) {
                        addCalculation(response)
                    }

                })

        } catch (error) {
            console.error('Error fetching calculated value:', error)
        }
    }

    const handleOnProviderChange = (e) => {
        changeDataValue("limitedCover", true);
        handleOnChangeBenefitWrapper(e);
    }

    const getBenefitText = (description) => {
        if (description === "Policy limit") {
            description = "Up to the policy limit"
        }
        return texts[description] !== undefined ? texts[description] : description;
    }

    return (
        <Fragment>
            {/*<span onClick={() => setIsOpen(true)}>{selectedBenefitsNames[benefit]}</span>*/}
            <select
                name={benefit}
                className={className}
                onChange={providersSignificant ? handleOnProviderChange : handleOnChangeBenefitWrapper}
                value={selectedBenefits?.[benefit] ?? 0}
                onClick={() => setIsOpen(!isOpen)}
                onBlur={() => setIsOpen(false)}
                onFocus={() => setIsOpen(false)}
            >

                <option value={0} disabled={true}>
                    {texts?.general_form_field_select ?? 'Select'}
                </option>

                {getOptions().map((item) => (
                    <option key={item.id} value={item.factor} data-description={item.description} data-id={item.id}>

                        <span>
                            {item.description}
                        </span>

                        {isPreferred(item.id) && isOpen &&
                            (selectedBenefits[benefit] !== item.factor || isOpen) && (
                                <span></span>
                            )}{" "}

                        {item.description === 'Worldwide Excl. Premium Countries' && <span>(*)</span>}
                    </option>

                ))}


            </select>
            {validator &&
                <div className={`${styleForm.validador}`}>
                    <ValidaComponent benefit={true} keyName={benefit} styleGroup={`${styleForm.valida}`}></ValidaComponent>
                </div>
            }
        </Fragment>

    );
};

export default SelectBenefitsComponent;
